// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid--grid--rVXEF","gridItem":"Grid--gridItem--5I_mr","Wide":"Grid--Wide--3JvJU","Tall":"Grid--Tall--1b2vF","Big":"Grid--Big--3wrWm","debug":"Grid--debug--24W_G"};